import { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'

import { UseSendSmsCodeAgainLogicReturnProps } from '../ContractSigningPageProps'
import { AppState } from '../../../store'


/**
 * Hooks obsługujący logikę ponownej wysyłki kodu sms.
 */
const useSendSmsCodeAgainLogic = (): UseSendSmsCodeAgainLogicReturnProps  => {
   const globalConfigurationState = useSelector((state: AppState) => state.lenConfigState.globalConfig)
   const [isSended, setIsSended] = useState<boolean>(false)
   const [isAfterInitialBlockingTime, setIsAfterInitialBlockingTime] = useState<boolean>(false)
   const [canSendSmsAgain, setCanSendSmsAgain] = useState<boolean>(false)


// >>>>> USE EFFECT
   useEffect(() => {
      const timer = setTimeout(() => {
         if(isAfterInitialBlockingTime){
            setCanSendSmsAgain(true)
         }
       }, globalConfigurationState.sendSmsBlockingTimeInMs)

       return () => clearTimeout(timer)
   // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [canSendSmsAgain])

   useEffect(() => {
      const timer = setTimeout(() => {
         setCanSendSmsAgain(true)
         setIsAfterInitialBlockingTime(true)
       }, globalConfigurationState.sendSmsInitialBlockingTime)
       
       return () => clearTimeout(timer)
   // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [])


   return {
      canSendSmsAgain,
      setCanSendSmsAgain,
      setIsSended,
   }
}

export default useSendSmsCodeAgainLogic